export interface Property {
  propertyTypes: any[] | null
  propertyTypesMain: any[] | null
  propertyTypesHouse: any[] | null
  propertyTypesFlat: any[] | null
  floors: any[] | null
}

export const state = (): Property => ({
  propertyTypes: null,
  propertyTypesMain: null,
  propertyTypesHouse: null,
  propertyTypesFlat: null,
  floors: null
})

export const GET_PROPERTY_TYPES = "getPropertyTypes"
export const GET_PROPERTY_TYPES_MAIN = "getPropertyTypesMain"
export const GET_PROPERTY_TYPES_HOUSE = "getPropertyTypesHouse"
export const GET_PROPERTY_TYPES_FLAT = "getPropertyTypesFlat"
export const GET_FLOORS = "getFloors"

export const getters = {
  [GET_PROPERTY_TYPES](state: any) {
    return state.propertyTypes
  },

  [GET_PROPERTY_TYPES_MAIN](state: any) {
    return state.propertyTypesMain
  },

  [GET_PROPERTY_TYPES_HOUSE](state: any) {
    return state.propertyTypesHouse
  },

  [GET_PROPERTY_TYPES_FLAT](state: any) {
    return state.propertyTypesFlat
  },

  [GET_FLOORS](state: any) {
    return state.floors
  }
}

export const _SET_PROPERTY_TYPES = "setPropertyTypes"
export const _SET_PROPERTY_TYPES_MAIN = "setPropertyTypesMain"
export const _SET_PROPERTY_TYPES_HOUSE = "setPropertyTypesHouse"
export const _SET_PROPERTY_TYPES_FLAT = "setPropertyTypesFlat"
export const _SET_FLOORS = "setFloors"

export const mutations = {
  [_SET_PROPERTY_TYPES](state: Property, propertyTypes: any[]) {
    state.propertyTypes = propertyTypes
  },

  [_SET_PROPERTY_TYPES_MAIN](state: Property, propertyTypes: any[]) {
    state.propertyTypesMain = propertyTypes
  },

  [_SET_PROPERTY_TYPES_HOUSE](state: Property, propertyTypes: any[]) {
    state.propertyTypesHouse = propertyTypes
  },

  [_SET_PROPERTY_TYPES_FLAT](state: Property, propertyTypes: any[]) {
    state.propertyTypesFlat = propertyTypes
  },

  [_SET_FLOORS](state: Property, floors: any[]) {
    state.floors = floors
  }
}

export const ADD_PROPERTY_TYPES = "addPropertyTypes"
export const ADD_PROPERTY_TYPES_HOUSE = "addPropertyTypesHouse"
export const ADD_PROPERTY_TYPES_FLAT = "addPropertyTypesFlat"
export const ADD_FLOORS = "addFloors"

export const actions = {
  [ADD_PROPERTY_TYPES]({ commit }, propertyTypes: any[]) {
    const house = propertyTypes.find(item => item.identifier === "house")
    const flat = propertyTypes.find(item => item.identifier === "flat")
    const other = propertyTypes.find(item => item.identifier === "other")
    commit(_SET_PROPERTY_TYPES, [...house.values, ...flat.values, ...other.values])

    const propertyTypesMapped = ["House", "Flat"].map(type => {
      const item = propertyTypes.find(item => item.identifier === type.toLowerCase())
      const mapped: any = { name: item.label, value: type }
      if (item.identifier === "flat") {
        mapped.propertyWithLevels = true
      }
      return mapped
    })
    commit(_SET_PROPERTY_TYPES_MAIN, [...propertyTypesMapped, ...other.values])
  },

  [ADD_PROPERTY_TYPES_HOUSE]({ commit }, propertyTypes: any[]) {
    commit(_SET_PROPERTY_TYPES_HOUSE, propertyTypes)
  },

  [ADD_PROPERTY_TYPES_FLAT]({ commit }, propertyTypes: any[]) {
    commit(_SET_PROPERTY_TYPES_FLAT, propertyTypes)
  },

  [ADD_FLOORS]({ commit }, floors: any[]) {
    commit(_SET_FLOORS, floors)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
